import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../Button/Button.js';
import Icon from '../../Icon/Icon.js';
import styles from './DismissWizardButton.module.scss.js';

var DismissWizardButton = function DismissWizardButton(_ref) {
  var onClose = _ref.onClose,
    closeText = _ref.closeText;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    dataTestId: "close-wizard",
    text: closeText,
    onClick: onClose,
    link: true,
    className: styles.mobile
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: styles.desktop,
    onClick: onClose,
    id: "close-wizard-desktop"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "icon-close",
    size: "mediumplus"
  })));
};
DismissWizardButton.propTypes = {
  onClose: PropTypes.func.isRequired,
  closeText: PropTypes.string
};
DismissWizardButton.defaultProps = {
  closeText: null
};

export { DismissWizardButton as default };
